module.exports = __webpack_public_path__ + "static/media/unhappy.dcf21601.svg";